<template>
  <section>
    <h2 class="h3 mb-3 mt-5">Payment Details</h2>
    <div class="f-form">
      <div class="f-form__half f-form__half--solo">
        <f-text
          id="paymentsDue"
          label="Payments Due"
          type="date"
          :value="value.payments_due"
          hint="NOTE: Email reminders for unpaid invoices will be sent at 12PM (AEST) the day before payments are due."
          :error="e('payments_due')"
          @input="update('payments_due', $event)"
        />
      </div>

      <div class="f-form__half f-form__half--solo">
        <f-checkbox
          id="onlinePaymentsOnly"
          label="Card Payments Only"
          :value="value.online_payments_only"
          :disabled="!isStripeVerified"
          @input="update('online_payments_only', $event)"
        />
        <small v-if="!isStripeVerified" class="form-text text-muted mt-1">
          The feature to accept online payments exclusively will be available after Stripe verifies the committee account.
        </small>
      </div>

    </div>
  </section>
</template>

<script>
import FText from '@/components/FormFields/FText'
import FCheckbox from '@/components/FormFields/FCheckbox'

export default {
  name: 'PaymentDetailsSection',
  components: { FText, FCheckbox },
  props: {
    value: { type: Object, required: true },
    isStripeVerified: { type: Boolean, default: false },
    errors: { type: Object, default: () => ({}) }
  },
  methods: {
    e(field) {
      return this.errors[field] ? this.errors[field][0] : null
    },
    update(field, val) {
      this.$emit('input', { ...this.value, [field]: val })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Drafts/PaymentDetailsSection.vue